import axios from 'axios'
import { capitalize } from 'lodash-es'

function formatFieldErrors (errors) {
  if (typeof errors !== 'object' || errors === null) {
    return null
  }

  const keys = Object.keys(errors)
  if (keys.length === 0) {
    return null
  }

  const firstKey = keys[0]
  const firstVal = errors[firstKey]
  if (Array.isArray(firstVal) && firstVal.length > 0) {
    return `${capitalize(firstKey)}: ${firstVal[0]}`
  }

  return null
}

export function getResponseErrorMessage (error) {
  if (error == null || !axios.isAxiosError(error)) {
    return null
  }

  const { response } = error
  if (!response || response.data == null) {
    return null
  }

  const data = response.data

  if (typeof data === 'string') {
    return null
  }

  if (data.message && typeof data.message === 'string') {
    return data.message
  }

  if (data.error) {
    if (typeof data.error !== 'string') {
      return null
    }

    return data.error
  }

  if (data.errors) {
    return formatFieldErrors(data.errors)
  }

  if (typeof data === 'object') {
    return formatFieldErrors(data)
  }

  return null
}

export async function getAllRecords (url, limit = 500) {
  const finalUrl = url.includes('?') ? `${url}&limit=${limit}` : `${url}?limit=${limit}`
  const firstPageResponse = await axios.get(finalUrl)
  const firstPageRecords = firstPageResponse.data
  const numberOfPages = parseInt(firstPageResponse.headers['total-pages'])

  if (numberOfPages === 1) {
    return firstPageRecords
  }

  const promises = []
  // we've fetched the 1st page already
  for (let page = 2; page <= numberOfPages; page++) {
    const pageUrl = `${finalUrl}&page=${page}`
    promises.push(axios.get(pageUrl))
  }

  const pagesResults = await Promise.all(promises)
  return pagesResults.reduce((results, resultsForPage) => results.concat(resultsForPage.data), firstPageRecords)
}
